import { ApiService } from '@stores/ApiService';
import { apiResponse } from '@stores/index';

export class OnboardingSurveyStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  async readByCohortId(cohortId: number) {
    try {
      const response = await this.api.get(`Cohort/${cohortId}/onboardingSurvey`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
